module.exports = __webpack_public_path__ + "static/media/history-02.72ef5b96.jpg";